import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import { List, Setting } from './components'
import { Loading } from 'components'

import { useToggle, useInput, useTitle } from 'utils'
import PosterEvaluationIcon from '../../components/PosterEvaluationIcon';

const listLayout = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 6,
  xl: 6
}


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
  tabContainer: {
    padding: 5,
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'center',
    // justifyContent: 'center',
    overflow: 'hidden',
  },
}))


function searchAndSortWorks(works, searchValue, sortValue) {
  const searchedList = works.filter(({ TITLE, AUTHOR, AXIS }) => {
    return TITLE.toLowerCase().includes(
      searchValue.toLowerCase()) ||
      AUTHOR.toLowerCase().includes(searchValue.toLowerCase()) ||
      AXIS.toLowerCase().includes(searchValue.toLowerCase())
  })

  const sortedList = searchedList.sort(function (a, b) {
    if (a[sortValue] < b[sortValue]) { return -1; }
    if (a[sortValue] > b[sortValue]) { return 1; }
    return 0;
  })

  const finalList = sortedList
  return finalList
}

function TabContainer({ children, dir }) {
  const classes = useStyles();
  return (
    // <Typography component="div" dir={dir} className={classes.tabContainer}>
    //   {children}
    // </Typography>
    // <Grid item>
    //   {children}
    // </Grid>
    <Grid container spacing={32} justify="center" style={{marginTop: '5px', overflow: 'hidden'}}>
      {children}
    </Grid>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

function FullWidthTabs({ works, setWorks, handleFavoriteButton, handleBookmarksButton }) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const [sortValue, setLSortValue] = React.useState('')
  const { toggle, setToggle } = useToggle()
  const [searchValue, setSearchValue] = useInput()

  useTitle('Papers | PSE-2019');

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  function handleChangeIndex(index) {
    setValue(index);
  }

  const props = {
    toggle,
    setToggle,
    searchValue,
    setSearchValue,
    setLSortValue
  }

  let worksToShow = null
  let keynotes = null
  let orals = null
  let posters = null
  if (works) {
    worksToShow = searchAndSortWorks(works, searchValue, sortValue)
    orals = worksToShow.filter(value => value.TYPE.toLowerCase() === 'oral')
    keynotes = worksToShow.filter(value => value.TYPE.toLowerCase() === 'keynote')
    posters = worksToShow.filter(value => value.TYPE.toLowerCase() === 'poster')
  }

  return (
    <>
      <p style={{ textAlign: 'center' }}>
        Click on a work to open the abstract.
      </p>
      <p style={{ textAlign: 'center' }}>
        Click on the (<PosterEvaluationIcon/>) symbol to select a Poster for evaluation.
      </p>
      <Setting {...props} />
      <Grid container spacing={32} justify="center" style={{ marginTop: '5px' }}>
        <AppBar position="static" color="default" >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            // variant={null}
            centered
          >
            <Tab label="Oral" />
            <Tab label="Keynotes" />
            <Tab label="Posters" />
          </Tabs>
        </AppBar>
        <SwipeableViews slideStyle={{overflow: 'hidden'}}
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabContainer dir={theme.direction} style={{ marginTop: '5px' }}>
            {orals ? (orals.map((work, key) => (
              <Grid item key={work.ID} {...listLayout} style={{ padding: '5px 5px' }}>
                <List {...work}
                  // favorited={work.favorited} handleFavoriteButton={handleFavoriteButton}
                  bookmarked={work.bookmarked}
                  handleBookmarksButton={handleBookmarksButton}
                  />
              </Grid>
            ))) : <Loading></Loading>
            }
          </TabContainer>
          <TabContainer dir={theme.direction} style={{ marginTop: '5px' }}>
            {keynotes ? (keynotes.map((work, key) => (
              <Grid item key={work.ID} {...listLayout} style={{ padding: '5px 5px' }}>
                <List {...work}
                  favorited={work.favorited}
                  bookmarked={work.bookmarked}
                  handleBookmarksButton={handleBookmarksButton}
                  />
              </Grid>
            ))) : <Loading></Loading>
            }
          </TabContainer>
          <TabContainer dir={theme.direction} style={{ marginTop: '5px' }}>
            {posters ? (posters.map((work, key) => (
              <Grid item key={work.ID} {...listLayout} style={{ padding: '5px 5px', overflow: 'hidden' }}>
                <List {...work}
                  favorited={work.favorited}
                  bookmarked={work.bookmarked}
                  handleFavoriteButton={handleFavoriteButton}
                  handleBookmarksButton={handleBookmarksButton}
                  />
              </Grid>
            ))) : <Loading></Loading>
            }
          </TabContainer>
        </SwipeableViews>
      </Grid>
    </>
  );
}

export default FullWidthTabs;
